
// eslint-disable-next-line aveny/mui-import-rule
import { lighten, Theme, useTheme } from '@mui/material';
import EDTooltip from '../../BaseComponents/Tooltip/EDTooltip';
import EDBox from '../../BaseComponents/EDBox/EDBox';
import { IBusinessColorConfig } from '../../Features/Delsystem/_Common/Const/BusinessConfigs';

interface IProps {
  legendData: IBusinessColorConfig[];
  /** Visar inte tooltip, då tooltipen är den delen som tar mest renderingstid så kan det användas som
   *  optimering när man t.ex. scrollar en lista med många legendareas */
  disableTooltip?: boolean;
}
interface IStyleInfo {
  caption: string;
  colors: string[];
}
const mergeStyles = (
  styles: IBusinessColorConfig[],
  theme: Theme
): IStyleInfo => {
  //En style med striped men ingen egen färg kombineras med separata styles för vilken färg det är
  const stripeAll: boolean =
    styles.findIndex(style => style.striped && style.color == null) !== -1;
  return styles.reduce<IStyleInfo>(
    (prev, curr) => ({
      caption: prev.caption ? `${prev.caption}, ${curr.caption}` : curr.caption,

      colors:
        curr.color == null
          ? prev.colors
          : curr.striped || stripeAll
          ? [
              ...prev.colors,
              theme.customProperties.Legend[curr.color][
                curr.colorOpacity ?? 'full'
              ],
              lighten(
                theme.customProperties.Legend[curr.color][
                  curr.colorOpacity ?? 'full'
                ],
                0.3
              ),
            ]
          : [
              ...prev.colors,
              theme.customProperties.Legend[curr.color][
                curr.colorOpacity ?? 'full'
              ],
            ],
    }),
    {
      caption: '',
      colors: [],
    }
  );
};

// Background css för en lista av färger. Randigt om det är flera färger
const background = (colors: string[]): string | undefined =>
  colors.length === 0
    ? undefined
    : colors.length === 1
    ? colors[0]
    : `repeating-linear-gradient(45deg,${colors.map(
        (color, idx) => `${color} ${idx * 8}px, ${color} ${(idx + 1) * 8}px`
      )})`;

const LegendArea: React.FC<React.PropsWithChildren<IProps>> = props => {
  const theme = useTheme();
  const style: IStyleInfo = mergeStyles(props.legendData, theme);
  return (
    <EDTooltip title={props.disableTooltip ? null : style.caption}>
      <EDBox
        style={{
          background: background(style.colors),
          width: '100%',
          height: '100%',
        }}
      />
    </EDTooltip>
  );
};

export default LegendArea;
